import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Table from "/src/components/table";
import httpLogsService from "/src/features/administration/logs/services/httpLogsService";
import { formatDateWithoutSeconds } from "/src/utils/dateWithoutSeconds";

function CompanyHttpLogsTable({ companyId }) {
    const navigate = useNavigate();

    useEffect(() => {
        if (!companyId) {
            navigate("/administration/company/list");
        }
    }, [companyId, navigate]);

    const cells = [
        { column: "Date", name: "requested_at", sort: true, show: (v) => formatDateWithoutSeconds(v, true) },
        { column: "Path", name: "path" },
        { column: "Method", name: "method", show: (v) => <span className={`http-method ${v}`}>{v}</span> },
        { column: "Status", name: "status_code", sort: true },
        { column: "Duration (ms)", name: "query_time", sort: true },
        { column: "IP", name: "ip_address" },
        { column: "User", name: "username" },
    ];

    const filters = [
        { type: "input", placeholder: "Method", name: "method" },
        {
            type: "input",
            placeholder: "Status",
            name: "status_code",
        },
        { type: "input", placeholder: "User", name: "username" },
    ];

    return (
        <Table
            name="company api log"
            style={{ top: "0px" }}
            cells={cells}
            api={(apiParams) => httpLogsService.getCompanyLogs(companyId, { ...apiParams })}
            actions={[]}
            buttons={[]}
            filters={filters}
        />
    );
}

export default CompanyHttpLogsTable;
